import { render, staticRenderFns } from "./FormInputTextarea.vue?vue&type=template&id=28d1acfa&scoped=true"
import script from "./FormInputTextarea.vue?vue&type=script&lang=js"
export * from "./FormInputTextarea.vue?vue&type=script&lang=js"
import style0 from "./FormInputTextarea.vue?vue&type=style&index=0&id=28d1acfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d1acfa",
  null
  
)

export default component.exports